<form [formGroup]="searchForm">
  <div>
    <mat-form-field>
      <mat-label>{{ title || 'input-part' | translate }}</mat-label
      ><input
        type="text"
        matInput
        [matAutocomplete]="autoCompletePart"
        formControlName="part"
        required
      />
      <mat-icon
        matSuffix
        (click)="openCustomPartModal()"
        fontIcon="bosch-ic-add-frame"
        id="partAutoComplete-input-icon-add"
      ></mat-icon>
      <mat-autocomplete
        autoActiveFirstOption
        #autoCompletePart="matAutocomplete"
      >
        <mat-option disabled class="loading" *ngIf="loading">
          <mat-spinner diameter="25"></mat-spinner>
        </mat-option>
        <mat-option
          *ngFor="let part of parts"
          (onSelectionChange)="handlePartChange($event, part)"
          [value]="part.searchName"
          class="autocomplete"
        >
          {{ part.searchName }}
        </mat-option>
      </mat-autocomplete>
      <mat-error *ngIf="!this.searchForm.valid"
        >{{ requiredText || "required-part" | translate }}</mat-error
      >
    </mat-form-field>
  </div>
</form>
